import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import WeightInput from "../WeightInput";
import DialogWithTrigger from "../DialogWithTrigger";

interface Props {
  onChange: (data: any) => void;
  data?: { value: string };
}

export default function QuestionTypeWeight(props: Props) {
  const { t } = useTranslation();

  function onChange(value: string) {
    const isValid = Number(value) > 0 && Number(value) < 500;
    props.onChange({
      data: { value: value },
      isValid: isValid,
    });
  }

  return (
    <Stack spacing={4} justifyContent="space-between">
      <Typography variant="h3">{t("QuestionTypeWeight.title")}</Typography>
      <WeightInput value={props?.data?.value} onChange={onChange} />
      <DialogWithTrigger
        title={t("WhyAreWeAskingYouThisModal.title")}
        description={t("QuestionTypeWeight.modalContent")}
      />
    </Stack>
  );
}
